"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var SwiperPlug = __importStar(require("swiper/react"));
var ra_fetch_1 = require("ra-fetch");
var breakpoints = {
    '0': {
        'slidesPerView': 1.5,
        'slidesPerGroup': 1.5,
    },
    '768': {
        'slidesPerView': 3.5,
        'slidesPerGroup': 3.5,
    },
    '992': {
        'slidesPerView': 4.5,
        'slidesPerGroup': 4.5,
    },
};
function Channels() {
    var _a = ra_fetch_1.useApi('backend').index('public.channels.homepage', {
        paginate: 3,
        page: 1,
        sort: 'created_at asc',
    }), channels = _a[0], setChannels = _a[1], params = _a[2], setParams = _a[3];
    return react_1.default.createElement("div", { className: 'storybook-home-channels' },
        channels.data.map(function (channel, index) {
            if (channel.videos.length > 0) {
                return react_1.default.createElement("div", { className: 'storybook-home-channel', key: index },
                    react_1.default.createElement("a", { href: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/kanalen/" + channel.name },
                        react_1.default.createElement("div", { className: 'storybook-home-channel-heading' },
                            react_1.default.createElement("figure", { style: { backgroundImage: "url(" + channel.logo + ")" } }),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("h3", null, channel.label),
                                react_1.default.createElement("span", null,
                                    channel.videos.length,
                                    " ",
                                    channel.videos.length === 1 ? 'video' : 'video\'s')))),
                    react_1.default.createElement(storybook_1.Layouts.Swiper, { className: 'storybook-home-channels-swiper', spaceBetween: 10, slidesPerView: 4.5, breakpoints: breakpoints }, channel.videos.map(function (video, index) {
                        return react_1.default.createElement(SwiperPlug.SwiperSlide, { key: index },
                            react_1.default.createElement(storybook_1.Videos.Card, { video: video }));
                    })));
            }
        }),
        react_1.default.createElement(storybook_1.Lists.Lazyload, { loading: channels.loading, load: channels.meta.current_page !== channels.meta.last_page, onEnter: function () { return setParams(__assign(__assign({}, params), { page: channels.meta.current_page + 1 }), true); } }));
}
exports.default = Channels;
